import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotResources from './components/HotResources';
import LatestResources from './components/LatestResources';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/faqs';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "一级免费网站免费资源导航平台 - 免费网站资源大全",
            "description": "一级免费网站免费资源汇聚平台，为您提供海量免费网站资源、免费工具、免费素材一站式获取。",
            "url": "https://dayangyouyu.cn/"
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotResources />
        <LatestResources />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}